import React, { Component } from 'react'
import { find } from 'lodash'
import { connectSortBy } from 'react-instantsearch/connectors'
import Dropdown from './Dropdown'

class SortBy extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isHydrated: false
    }
  }

  componentDidMount() {
    // Mark the component as hydrated once it is mounted
    this.setState({ isHydrated: true })
  }

  get selectedValue() {
    const { items, currentRefinement, initialTitle } = this.props
    const { isHydrated } = this.state

    if (!isHydrated) {
      // During SSR or before hydration, use initialTitle for consistency
      return initialTitle
    }

    // After hydration, use the actual refinement value
    const selectedItem = find(items, { value: currentRefinement })
    return selectedItem?.label || initialTitle
  }

  handleClick(value) {
    this.props.refine(value)
  }

  render() {
    const { items } = this.props
    return (
      <div className="sort-by">
        <span className="sort-by-title">Trier par :</span>
        <Dropdown
          borderless
          title={this.selectedValue}
          refined
          className="sort-search-results">
          {items.map((item) => (
            <div key={item.value} className="feature-filter">
              <div
                className="feature-option"
                onClick={() => this.handleClick(item.value)}>
                {item.label}
              </div>
            </div>
          ))}
        </Dropdown>
      </div>
    )
  }
}

export default connectSortBy(SortBy)
